module.exports = __webpack_public_path__ + "img/材料力学8_10.0c1da72b.jpg";